import { CreateElement, Rect, Scale, Size } from "../MyHelpers";
import { ZIndex } from "../ZIndex";

export interface MarkersInfoColors
{
	MarkerbackgroundColor:string;	
}

export class WinInfoMarker
{
	public element: HTMLElement;
	public containerElement: HTMLElement;

	public lineIndex: number;
	public backgroundElement : HTMLElement;

	public constructor() 
	{
		this.containerElement = CreateElement("div", {classes: ["line-marker-container"], style: {
			//flexGrow: "1",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			//height : "100%",
			margin : "auto",
			//padding : Scale.fhpx(5),
			
		}});

		

		
		

		this.element = CreateElement("div", {classes: ["line-marker-number"], innerHTML: "00", style: {
			borderRadius: Scale.XYpx(25),
			width: "100%",
			height : "100%",
			textAlign: "center",
			fontFamily: "NotoSansDisplay-Bold", // default font
			fontSize: Scale.fhpx(35),
			color: "white",
			textShadow: "2px 2px 2px black, 2px -2px 2px black, -2px -2px 2px black",
			margin: "auto",
			display : "block",
			
			
		}});
		this.element.style.zIndex=ZIndex.WinLines.toString();

		this.containerElement.appendChild(this.element);
	}

	public Show(lineIndex: number): void {
		this.element.innerHTML = "" + (lineIndex + 1);
		this.element.style.visibility = "visible";
	}

	// public Hide(): void {
	// 	this.element.style.visibility = "hidden";
	// }
}

export class WinsLinesInfoMarkers
{
	private leftMarkers: WinInfoMarker[] = [];
	private leftVisibleMarker: WinInfoMarker = null;

	private rightMarkers: WinInfoMarker[] = [];
	private rightVisibleMarker: WinInfoMarker = null;

	private leftContainer: HTMLElement = null;
	private rightContainer: HTMLElement = null;

	private leftGroup : HTMLElement []= [];
	private rightGroup : HTMLElement []= [];


	//private view: HTMLElement = null;
	private lines: number[][] = [];
	
	protected leftWidth: number = Scale.W(50);
	protected leftOffset: number = Scale.X(10);

	protected rightWidth: number = Scale.W(50);
	protected rightOffset: number = Scale.X(10);
	protected symbolHeight : number ;
	protected slotWindow: Rect;
	constructor(slotWindow: Rect, slotWindowSymbolSize: Size, lines: number[][]) 
	{
		this.symbolHeight = slotWindow.height / slotWindowSymbolSize.Height;
		this.lines = lines;	
		this.slotWindow = slotWindow;
	}

	public CreateGroups(color : MarkersInfoColors){
		
		let cssBacgkround: Partial<CSSStyleDeclaration> = {
			borderRadius: Scale.XYpx(30),    
            border: `${Scale.XYpx(5)} solid transparent`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",           
            justifyContent: "space-evenly",        
            backgroundOrigin: "border-box",
            backgroundClip: "content-box, border-box",           
            backgroundImage: color.MarkerbackgroundColor,			
        };

		this.leftContainer = CreateElement("div", {classes: ["line-markers-left"], style: {
			position: "absolute",
			top: this.slotWindow.y + "px",
			height: this.slotWindow.height + "px",
			left: (this.slotWindow.x - this.leftWidth - this.leftOffset) + "px",
			width: this.leftWidth + "px",
			display: "flex",
			flexDirection: "column-reverse",
			alignItems: "center",
			...cssBacgkround,	
			justifyContent : "center",	
		}});

		this.leftContainer.style.zIndex=ZIndex.WinLines.toString();

		this.rightContainer = CreateElement("div", {classes: ["line-markers-right"], style: {
			position: "absolute",
			top: this.slotWindow.y + "px",
			height: this.slotWindow.height + "px",
			left: (this.slotWindow.x + this.slotWindow.width + this.rightOffset) + "px",
			width: this.rightWidth + "px",
			display: "flex",
			flexDirection: "column-reverse",
			alignItems: "center",
			...cssBacgkround,
			justifyContent : "center",
		}});

		this.rightContainer.style.zIndex=ZIndex.WinLines.toString();

		let groups = Math.round(this.lines.length / 5);
		let newIndex = 0;
		let howManygroupNeeit = 6;
		if (this.lines.length <= 5  ) {
			howManygroupNeeit = 5
		}
		

		//CREATE 3 GROUPS
		for (let group = 0; group < howManygroupNeeit; group++) {
			this.leftGroup[group] = CreateElement("div", {
				classes: ["line-markers-groupLeft-" + group], style: {
					position: "relative",
					height: this.slotWindow.height / 6 + "px",
					width: this.rightWidth + "px",
					display: "flex",
					alignContent: "center",
					flexDirection: "flex-direction",
					justifyContent: "center",
					borderTop: Scale.fhpx(1) + "inset black",

				}
			});
			if (group == howManygroupNeeit -1 ) {
				this.leftGroup[group].style.borderTop = Scale.fhpx(1) + "inset transparent";
				this.leftGroup[group].style.color = "yellow";
			}

			this.leftContainer.appendChild(this.leftGroup[group]);

			this.rightGroup[group] = CreateElement("div", {
				classes: ["line-markers-groupRight-" + group], style: {
					position: "relative",
					height: this.slotWindow.height / 6 + "px",
					width: this.rightWidth + "px",
					display: "flex",
					alignContent: "center",
					flexDirection: "column",
					justifyContent: "center",
					borderTop: Scale.fhpx(1) + "inset black",
				}
			});
			if (group == howManygroupNeeit -1) {
				this.rightGroup[group].style.borderTop = Scale.fhpx(1) + "inset transparent";
				this.leftGroup[group].style.color = "yellow";
			}
			this.rightContainer.appendChild(this.rightGroup[group]);

		}

		
		

		for (let lineIndex = 0; lineIndex < howManygroupNeeit; lineIndex++) {

			newIndex = lineIndex * groups;

			//console.log("NewIndex:", newIndex);
			// create markers
			let leftMarker: WinInfoMarker = new WinInfoMarker();
			let rightMarker: WinInfoMarker = new WinInfoMarker();

			//Append Left Group
			this.leftGroup[lineIndex].appendChild(leftMarker.containerElement);

			if (groups != 1 && lineIndex != 0) {
				newIndex = newIndex - 1;
			}
			if (lineIndex == howManygroupNeeit - 1) {
				leftMarker.element.style.color = "yellow";
				leftMarker.element.style.textShadow = "2px 2px 2px red, 2px -2px 2px red, -2px -2px 2px red",
				leftMarker.element.style.fontSize = Scale.fhpx(45);
				leftMarker.Show(newIndex);
			}
			else {

				leftMarker.Show(newIndex);

			}
			//Append Right Group			
			this.rightGroup[lineIndex].appendChild(rightMarker.containerElement);

			if (lineIndex == howManygroupNeeit - 1) {
				rightMarker.element.style.color = "yellow";
				rightMarker.element.style.textShadow = "2px 2px 2px red, 2px -2px 2px red, -2px -2px 2px red",
					rightMarker.element.style.fontSize = Scale.fhpx(45);
				rightMarker.Show(newIndex);
			}
			else {
				rightMarker.Show(newIndex);
			}

			// hide markers by default		
			this.leftMarkers.push(leftMarker);
			this.rightMarkers.push(rightMarker);

		}
	}

	public Show(lineIndex: number): void {


		let rowLeft = this.lines[lineIndex][0];


		this.leftVisibleMarker = this.leftMarkers[lineIndex];
		this.leftVisibleMarker.backgroundElement.style.transform = "scale(1.25)";
		// this.leftVisibleMarker.Show(lineIndex);

		let rowRight = this.lines[lineIndex][this.lines[lineIndex].length - 1];

		this.rightVisibleMarker = this.rightMarkers[lineIndex];
		this.rightVisibleMarker.backgroundElement.style.transform = "scale(1.25)";
		// this.rightVisibleMarker.Show(lineIndex);
	}



	public Hide(): void {
		if (this.leftVisibleMarker != null) {
			this.leftVisibleMarker.backgroundElement.style.transform = "scale(1)";
			this.leftVisibleMarker = null;
		}

		if (this.rightVisibleMarker != null) {
			this.rightVisibleMarker.backgroundElement.style.transform = "scale(1)";
			this.rightVisibleMarker = null;
		}
	}

	public LeftView(): HTMLElement {
		return this.leftContainer;
	}

	public RightView(): HTMLElement {
		return this.rightContainer;
	}


	protected color : MarkersInfoColors;
	public SaveColor(color: MarkersInfoColors)
	{       
		this.color = color;
	}
}